import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The compliance tree used to live at `/$org/regulation/…`. Every link, open
 * tab and bookmark pointing there still resolves: this catch-all forwards the
 * whole remaining path to the same page under `/$org/compliance/…`, so a
 * rename of the route never costs a user their place.
 *
 * Permanent by intent — nothing new should be written against the old prefix.
 */
export const Route = createFileRoute("/$org/regulation/$")({
  beforeLoad: ({ params, location }) => {
    // `href`, not `to`: the destination is assembled from the splat at
    // runtime, so it cannot be one of the router's literal route ids.
    const rest = params._splat ?? "";
    throw redirect({
      href: `/${params.org}/compliance${rest ? `/${rest}` : ""}${location.searchStr}`,
      replace: true,
    });
  },
});
